import {getUserPermissions} from '../../utils/userPermissions'

export default function() {
  return {
    items: [
      getUserPermissions('core.dasboard.dasboard') && {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      },
      // {
      //   name: 'Dictionary',
      //   url: '/dictionary',
      //   icon: 'fa fa-book fa-lg'
      // },
      getUserPermissions('wl_welds.projects.index') && {
        name: 'Projects',
        url: '/projects',
        icon: 'fa fa-table fa-lg',
      },
      getUserPermissions('wl_welds.show_wps_list.show_wps_list') && {
        name: 'WPS',
        url: '/wps',
        icon: 'fa fa-file-text-o fa-lg',
      },
      getUserPermissions('core.show_people_list.show_people_list') && {
        name: 'People',
        url: '/people',
        icon: 'fa fa-id-card-o fa-lg',
      },
      getUserPermissions('core.companies.index') && {
        name: 'Companies',
        url: '/companies',
        icon: 'fa fa-handshake-o fa-lg',
      },
      getUserPermissions('wl_welders.show_certificates_list.show_certificates_list') && {
        name: 'Welders',
        url: '/welders',
        icon: 'fa fa-user-circle-o fa-lg',
      },
      getUserPermissions('core.show_reports_list.show_reports_list') && {
        name: 'Reports',
        url: '/reports',
        icon: 'fa fa-line-chart fa-lg',
      },
      {
        name: 'Calculators',
        url: '/calculators',
        icon: 'fa fa-calculator fa-lg',
      },
      {
        name: 'Manual',
        url: '/manual',
        icon: 'fa fa-info-circle fa-lg',
      },
    ].filter(Boolean)
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js